import Axios from "axios";
import ManagerLocalStorage from "@/utils/managerLocalStorage.js";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

export default {
  serviceWorkerStart() {
    if (navigator.serviceWorker) {
      navigator.serviceWorker
        .register("/serviceWorker.min.js")
        .then(function (reg) {
          console.log(reg);
        })
        .catch(function (error) {
          console.log(error);
        });
      navigator.serviceWorker.ready.then(function (registration) {
        registration.active.postMessage({
          command: "SignOut",
          action: true,
        });
      });
    }
  },

  async verifyLogin(user) {
    var formData = new FormData();
    formData.append("username", user.username);
    formData.append("password", user.password);
    let response = await Axios.post("InicioDeSesion", formData);

    return response.data;
  },

  async recuperaPassword(uslogin) {
    var formData = new FormData();
    formData.append("uslogin", uslogin);
    let response = await Axios.post("RecuperarPassword", formData);
    return response.data;
  },

  async enviarSmsDesbloqueoLogin(data) {
    var formData = new FormData();
    formData.append("data", data);
    let response = await Axios.post("EnviarSmsDesbloqueoLogin", formData);
    return response.data;
  },

  async enviarCorreoDesbloqueoLogin(data) {
    var formData = new FormData();
    formData.append("data", data);
    let response = await Axios.post("EnviarCorreoDesbloqueoLogin", formData);
    return response.data;
  },

  async validarCodigoDesbloqueoLogin(codigo, uslogin, data) {
    var formData = new FormData();
    formData.append("codigo", codigo);
    formData.append("uslogin", uslogin);
    formData.append("data", data);
    let response = await Axios.post("ValidarCodigo", formData);
    return response.data;
  },

  async enviarCorreoNuevoDispositivo() {
    let response = await Axios.post("EnviarCorreoNuevoDispositivo");
    return response.data;
  },

  signOff(domainNameForApi, informationPage) {
    Axios.post(`${domainNameForApi}signOut`)
      .then((response) => {
        if (response.data) {
          ManagerLocalStorage.removeLocalStorage(
            informationPage.nameLocalStoragePGV2
          );
          MetodosGenerales.eliminaCookie(informationPage.nameCookiePGV2);
          setTimeout(() => {
            location.reload();
          }, 100);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
